import { render } from "./IconModal.vue?vue&type=template&id=bdd0e938&scoped=true"
import script from "./IconModal.vue?vue&type=script&lang=js"
export * from "./IconModal.vue?vue&type=script&lang=js"

import "./IconModal.vue?vue&type=style&index=0&id=bdd0e938&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\ft\\Coding\\GT Designer\\gtdesigner\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdd0e938"]])

export default __exports__